var platformAndBrowser = navigator.userAgent;
if (platformAndBrowser.match(/Mac/) && navigator.maxTouchPoints) {
	$('body').addClass('ipad');
} else if (platformAndBrowser.match(/iPhone/i)) {
	$('body').addClass('iphone');
} else if (platformAndBrowser.match(/Android/i)) {
	$('body').addClass('android');
} else if (platformAndBrowser.match(/Win32/i)) {
	$('body').addClass('win');
} else if (platformAndBrowser.match(/Win64/i)) {
	$('body').addClass('win');
}